import {
    flattenObject,
    AllStringValuesFormNestedObject,
} from '@manigo/manigo-commons';

// PermissionsNames -> PN
export const PN = Object.freeze({
    ACCOUNTS: {
        CREATE: 'accounts:create',
        DELETE: 'accounts:delete',
        READ: 'accounts:read',
        READ_BALANCES: 'accounts:read-balances',
        READ_BY_ID: 'accounts:read-by-id',
        SET_PRIMARY: 'accounts:set-primary',
        UPDATE: 'accounts:update',
        UPDATE_FLAGS: 'accounts:update-flags',
    },
    AUTH: { ACTIVITY: 'auth:activity' },
    BENEFICIARIES: {
        CREATE: 'beneficiaries:create',
        DELETE: 'beneficiaries:delete',
        GET_ALL: 'beneficiaries:get-all',
        READ_BY_ID: 'beneficiaries:read-by-id',
        REQUIRED_DETAILS: 'beneficiaries:required-details',
        UPDATE: 'beneficiaries:update',
    },
    BUSINESS_USERS: {
        READ: 'business-users:read',
        READ_BY_ID: 'business-users:read-by-id',
        UPDATE: 'business-users:update',
        UPDATE_PASSWORD: 'business-users:update-password',
        UPDATE_STATUS: 'business-users:update-status',
        ASSIGN_BU_ACCOUNT: 'business-users:assign-business-user-account',
        READ_BU_ACCOUNT_ASSIGNMENT:
      'business-users:read-business-user-account-assignment',
    },
    CARDS: {
        ACTIVATION: 'cards:activation',
        DELETE: 'cards:delete',
        ORDER_BULK: 'cards:order-bulk',
        ORDER_SINGLE: 'cards:order-single',
        READ: 'cards:read',
        READ_BY_ACCOUNT: 'cards:read-by-account',
        READ_BY_EMPLOYEE: 'cards:read-by-employee',
        READ_BY_ID: 'cards:read-by-id',
        SENSITIVE: 'cards:sensitive',
        RESET_CONTACTLESS_LIMIT: 'cards:reset-contactless-limit',
        TOGGLING: 'cards:toggling',
        UPDATE_CARD_SETTINGS: 'cards:update-card-settings',
        UNBLOCK_PIN: 'cards:unblock-pin',
        UPDATE_LIMITS: 'cards:update-limits',
        RETURN_ALL_COMPANY_CARD: 'cards:return-all-company-cards',
    },
    CARD_TIERS: { READ_ALL: 'card-tiers:read-all' },
    COMPANIES: {
        CREATE: 'companies:create',
        CREATE_EMPLOYEE: 'companies:create-employee',
        DELETE: 'companies:delete',
        READ: 'companies:read',
        READ_BY_ID: 'companies:read-by-id',
        READ_STAKEHOLDERS: 'companies:read-stakeholders',
        UPDATE: 'companies:update',
        UPDATE_EMPLOYEE: 'companies:update-employee',
        UPDATE_EMPLOYEE_PASSWORD: 'companies:update-employee-password',
    },
    CURRENCIES: { READ: 'currencies:read' },
    EXCHANGE: {
        CONFIRM: 'exchange:confirm',
        INIT: 'exchange:init',
        REJECT: 'exchange:reject',
    },
    EXCHANGE_RATES: { CURRENCY: 'exchange-rates:currency' },
    INDUSTRIES: { GET_ALL: 'industries:get-all' },
    KYB: { GET_ACCESS_TOKEN: 'kyb:get-access-token' },
    KYC: { GET_ACCESS_TOKEN: 'kyc:get-access-token' },
    PAYMENT_GATEWAY: { PAYMENT: 'payment-gateway:payment' },
    PAYMENTS: { CANCEL: 'payments:cancel' },
    REPORTS: {
        TRANSACTION_STATEMENT: {
            PDF: 'reports:transaction-statement:pdf',
            CSV: 'reports:transaction-statement:CSV',
        },
    },
    TRANSACTIONS: {
        MAKE_PAYMENT: 'transactions:make-payment',
        READ_ALL: 'transactions:read-all',
        READ_BY_ID: 'transactions:read-by-id',
        CREATE_ATTACHMENT: 'transactions:create-attachment',
        UPDATE_ATTACHMENT: 'transactions:update-attachment',
        DELETE_ATTACHMENT: 'transactions:delete-attachment',
    },
    USERS: {
        DELETE: 'users:delete',
        READ: 'users:read',
        READ_BY_ID: 'users:read-by-id',
        WRITE: 'users:write',
    },
});
export type PermissionNames = AllStringValuesFormNestedObject<typeof PN>;

const flatPN = flattenObject(PN);
type pnKeys = keyof typeof flatPN;

export type PermissionName = (typeof flatPN)[pnKeys];

export default { PN };
